import React from "react";
import { formatDate } from "../../i18n/dateLocale";
import { useTranslation } from "react-i18next";
import InputComponent from "../_common/inputComponent";

const UserTable = (props) => {
  const { t } = useTranslation();
  return (
    <div className="table-wrapper px-3 pt-3">
      <p className="table-type">{t("admin.users.table.allUsers")}</p>
      <div className="table-wrapper-scroll-y table-scrollbar">
        <div className="table-responsive table-own">
          <table className="table table-striped table-hover table-admin">
            <thead className="table-head">
              <tr>
                <th
                  className={`sort-header cursor ${props?.sortObj?.sortVal === "mobile" ? "active" : ""
                    }
                ${props?.sortObj?.sorType ? "asec" : "desc"}
                `}
                  onClick={() => props.arraySorting("mobile")}
                >
                  <span>{t("admin.users.table.phone")}</span>
                  {props?.sortObj?.sortType === "asec" && (
                    <i className="fas fa-caret-down"></i>
                  )}
                  {props?.sortObj?.sortType === "desc" && (
                    <i className="fas fa-caret-up"></i>
                  )}
                </th>
                <th
                  className={`sort-header cursor ${props?.sortObj?.sortVal === "postalCode" ? "active" : ""
                    }
                ${props?.sortObj?.sorType ? "asec" : "desc"}
                `}
                  onClick={() => props.arraySorting("postalCode")}
                >
                  <span>{t("admin.users.table.postCode")}</span>
                  {props?.sortObj?.sortType === "asec" && (
                    <i className="fas fa-caret-down"></i>
                  )}
                  {props?.sortObj?.sortType === "desc" && (
                    <i className="fas fa-caret-up"></i>
                  )}
                </th>
                <th>{t("admin.users.table.zone")}</th>
                <th
                  className={`sort-header cursor ${props?.sortObj?.sortVal === "dateOfBirth" ? "active" : ""
                    }
                ${props?.sortObj?.sorType ? "asec" : "desc"}
                `}
                  onClick={() => props.arraySorting("dateOfBirth")}
                >
                  <span>{t("admin.users.table.dateOfBirth")}</span>
                  {props?.sortObj?.sortType === "asec" && (
                    <i className="fas fa-caret-down"></i>
                  )}
                  {props?.sortObj?.sortType === "desc" && (
                    <i className="fas fa-caret-up"></i>
                  )}
                </th>
                <th
                  className={`sort-header cursor ${props?.sortObj?.sortVal === "gender" ? "active" : ""
                    }
                ${props?.sortObj?.sorType ? "asec" : "desc"}
                `}
                  onClick={() => props.arraySorting("gender")}
                >
                  <span>{t("admin.users.table.gender")}</span>
                  {props?.sortObj?.sortType === "asec" && (
                    <i className="fas fa-caret-down"></i>
                  )}
                  {props?.sortObj?.sortType === "desc" && (
                    <i className="fas fa-caret-up"></i>
                  )}
                </th>
                <th className={`text-center sort-header cursor ${props?.sortObj?.sortVal === "created" ? "active" : ""
                  }
                ${props?.sortObj?.sorType ? "asec" : "desc"}
                `}
                  onClick={() => props.arraySorting("created")}>
                  <span>{t("admin.users.table.registrationDate")}</span>
                  {props?.sortObj?.sortType === "asec" && (
                    <i className="fas fa-caret-down"></i>
                  )}
                  {props?.sortObj?.sortType === "desc" && (
                    <i className="fas fa-caret-up"></i>
                  )}
                </th>
                <th className="text-center">
                  <span>{t("admin.users.table.uuid")}</span>
                </th>
                <th className="text-center">
                  <span>{t("admin.users.table.emergencyOverride")}</span>
                </th>
                <th className={`text-center sort-header cursor ${props?.sortObj?.sortVal === "lastOverrideOn" ? "active" : ""
                  }
                ${props?.sortObj?.sorType ? "asec" : "desc"}
                `}
                  onClick={() => props.arraySorting("lastOverrideOn")}>
                  <span>{t("admin.users.table.lastOverride")}</span>
                  {props?.sortObj?.sortType === "asec" && (
                    <i className="fas fa-caret-down"></i>
                  )}
                  {props?.sortObj?.sortType === "desc" && (
                    <i className="fas fa-caret-up"></i>
                  )}
                </th>

                <th className={`text-center sort-header cursor ${props?.sortObj?.sortVal === "totalOverrides" ? "active" : ""
                  }
                ${props?.sortObj?.sorType ? "asec" : "desc"}
                `}
                  onClick={() => props.arraySorting("totalOverrides")}>
                  <span>{t("admin.users.table.totalOverride")}</span>
                  {props?.sortObj?.sortType === "asec" && (
                    <i className="fas fa-caret-down"></i>
                  )}
                  {props?.sortObj?.sortType === "desc" && (
                    <i className="fas fa-caret-up"></i>
                  )}
                </th>

                <th>
                  <span>{t("common.action")}</span>
                </th>
              </tr>
            </thead>
            <tbody className="table-body">
              {props.dataList.map((data, index) => {
                return (
                  <tr key={index}>
                    <td>{data?.mobile}</td>
                    <td>{data?.postalCode.toUpperCase()}</td>
                    <td>{data?.zone || t("common.na")}</td>
                    <td>
                      {data.dateOfBirth
                        ? formatDate(new Date(data?.dateOfBirth))
                        : t("common.na")}
                    </td>
                    <td className="text-capitalize">
                      {data?.gender && data.gender === "not_disclosed"
                        ? t("admin.users.table.notDisclosed")
                        : data.gender}
                    </td>
                    <td className="override text-center">
                      {data.created
                        ? formatDate(new Date(data?.created))
                        : t("common.na")}
                    </td>
                    <td className="override text-center">
                      {data?.uuid || t("common.na")}
                    </td>
                    <td className="override text-center">
                      <span
                        onClick={() => props?.emergencyOverride(data)}
                        className="cursor mr-1 btn btn-own-admin primary-btn btn-sm-own table-action"
                      >
                        {t("common.override")}
                      </span>
                    </td>
                    <td className="override text-center">
                      {data?.lastOverrideOn}
                    </td>
                    <td className="override text-center">
                      {data?.totalOverrides}
                    </td>
                    <td className="nowrap">
                      <span
                        onClick={() => props?.editData(data)}
                        className="btn btn-own-admin primary-btn btn-sm-own table-action"
                      >
                        {t("common.edit")}
                      </span>{" "}
                      |{" "}
                      <span
                        onClick={() => props?.deleteData(data)}
                        className="btn btn-own-admin primary-btn btn-sm-own table-action"
                      >
                        {t("common.delete")}
                      </span>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default UserTable;
